import { TimePicker } from "@mui/x-date-pickers";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time
import { format, parse } from "date-fns";

interface InterviewTimePickerFieldProps {
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  label?: string;
  disabled?: boolean;
}

export function InterviewTimePickerField(props: InterviewTimePickerFieldProps) {
  const { value, onChange, error, label, disabled } = props;
  const timeValue = parse(value, "HH:mm", new Date());

  return (
    <TimePicker
      skipDisabled
      ampm
      label={label}
      value={timeValue}
      disabled={disabled}
      slotProps={{
        textField: {
          size: "small",
          sx: {
            width: "140px",
            "& .MuiOutlinedInput-root": {
              borderRadius: 1.5,
            },
          },
          error,
        },
      }}
      minutesStep={15}
      onChange={(newValue) => {
        if (newValue) {
          onChange(format(newValue, "HH:mm"));
        }
      }}
    />
  );
}
